import { render, staticRenderFns } from "./cadestados.vue?vue&type=template&id=8055d3a6&"
import script from "./cadestados.vue?vue&type=script&lang=js&"
export * from "./cadestados.vue?vue&type=script&lang=js&"
import style0 from "./cadestados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports